module.exports = __webpack_public_path__ + "img/r1.5aa8dcc2.png";